import React, { FC, useCallback } from "react";
import TransparentPage from "../common/navigation/PageTransparent";
import * as sid from "../../utils/sid";

import CreateGeometry from "./components/CreateGeometry";
import F7 from "../../utils/F7";
import { useNavigate } from "react-router-dom";
import { InventoryGeometryItem } from "../../hooks/database/types/inventories";
import { useCreateObject } from "../../hooks/database/usePouchCreate";

const ObjectCreatePage: FC = () => {
  const navigate = useNavigate();

  const { execute: createObject } = useCreateObject();

  const handleConfirmClick = useCallback(
    (geom: InventoryGeometryItem["geom"]) => {
      const prompt = F7.prompt("Enter the new title", "", async (title: string) => {
        const resp = await createObject({
          type: "geometry",
          title,
          data: [],
          geom,
        });

        navigate(`../o/${resp._id}`);
      });
      const input = prompt.querySelector<HTMLInputElement>("input.modal-text-input");
      input!.value = sid.generate(5);
      input!.focus();
      input!.setSelectionRange(0, input!.value.length);
    },
    [createObject, navigate]
  );

  const handleCancelClick = useCallback(() => {
    navigate("../");
  }, [navigate]);

  return (
    <TransparentPage>
      <CreateGeometry onSave={handleConfirmClick} onCancel={handleCancelClick} />
    </TransparentPage>
  );
};

export default ObjectCreatePage;
